module.exports = __webpack_public_path__ + "img/42.5b5db19d.webp";